// extracted by mini-css-extract-plugin
export default {"custom-req-row":"CustomRequestRow_custom-req-row__syzZy"};